<script lang='ts'>
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  import type { ImageObj, Dimensions } from 'app/javascript/shared/javascripts/types/Images';
  import EnableSwitch from './EnableSwitch.svelte';
  export let storefront : Storefront;
  export let callbacks: any;
  import ImageUploadWidget from '@shared/svelte/Components/ImageUploadWidget.svelte';

  let headerObj : ImageObj
  let logoObj : ImageObj

  const logoAlignmentOptions = [
    {label: 'Center', value: 'center'},
    {label: 'Left', value: 'left'},
    {label: 'Right', value: 'right'},
  ];

  function updateStorefront() {
    callbacks.update(storefront);
  }

  const headerDimensions : Dimensions = {
    min_width: 1400,
    min_height: 300,
    max_file_size: 5
  }

  const logoDimensions : Dimensions = {
    min_width: 150,
    min_height: 150,
    max_file_size: 5
  }

  $: {
    headerObj = {
      cloudinary_image_url: storefront.header_image_cloudinary_url,
      id: storefront.id, image_upload_id: storefront.header_image_id
    }
    logoObj = {
      cloudinary_image_url: storefront.logo_image_cloudinary_url,
      id: storefront.id, image_upload_id: storefront.logo_image_id
    }
  }

</script>
<form class="fizz-text-small" id='header_image_upload'>
  <p class="fizz-label fizz-stack-8">Header Image</p>
  <ImageUploadWidget obj={headerObj} entityType='StorefrontHeader' postRemoveCB={callbacks.refreshStorefront}
    propertyOverride={'header_image_id'} postSaveCB={callbacks.refreshStorefront} setLoading={callbacks.setLoading}
    dimensions={headerDimensions}></ImageUploadWidget>
</form>

<form class="fizz-text-small logo_image_upload">
  <p class="fizz-label fizz-stack-8 fizz-space-between">
    <span>Logo</span>
    <EnableSwitch bind:val={storefront.enable_logo} changeCB={updateStorefront} domId={'logo'}></EnableSwitch>
  </p>
  {#if storefront.enable_logo}
    <ImageUploadWidget obj={logoObj} entityType='StorefrontLogo' postRemoveCB={callbacks.refreshStorefront}
      propertyOverride={'logo_image_id'} postSaveCB={callbacks.refreshStorefront} setLoading={callbacks.setLoading}
      dimensions={logoDimensions}></ImageUploadWidget>
    <label class="fizz-label fizz-stack-8" for="logo_alignment">Logo Alignment</label>
    <select class="fizz-select"
      name="logo_alignment" id='logo_alignment'
      bind:value={storefront.logo_alignment}
      on:change={updateStorefront}
    >
      {#each logoAlignmentOptions as logoAlignment }
        <option value={logoAlignment.value}>{logoAlignment.label}</option>
      {/each}
    </select>
  {/if}
</form>